import { Schema, arrayOf } from 'normalizr'

const user = new Schema('users')
const aliada = new Schema('aliadas')
const recurrence = new Schema('recurrences')
const service = new Schema('services')

recurrence.define({
  aliada
})

service.define({
  aliada
})

export const USER = user

export const ALIADA = aliada
export const ALIADA_ARRAY = arrayOf(aliada)

export const RECURRENCE = recurrence

export const SERVICE = service



// WEBPACK FOOTER //
// ./src/services/api/schemas.js